import React from 'react';
import {Link} from "react-router-dom";


const Navegacion = ({desactivado}) => {
    
    return ( 
<div className={desactivado ? "desactivado" : "activado"}>
          <Link className={desactivado ? "A" : "A blancoTxt"} to={`/crear-usuario`}>Inicio</Link>
          <Link className={desactivado ? "A" : "A blancoTxt"} to={`/iniciar-sesion`}>Servicios</Link>
          <Link className={desactivado ? "A" : "A blancoTxt"} to={`/admin/administrador/productos/nuevo-producto`}>Nosotros</Link>
          <Link className={desactivado ? "A" : "A blancoTxt"} to={`/admin/administrador/productos`}>contacto</Link>
        </div>
     );
}
 
export default Navegacion;